import { render } from "./activities.vue?vue&type=template&id=5417fda7"
import script from "./activities.vue?vue&type=script&lang=js"
export * from "./activities.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-waha\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__